import Chartkick from 'chartkick'
import Chart from 'chart.js/auto'
import 'chartjs-adapter-date-fns'

// Make Chart.js available globally for Chartkick
window.Chart = Chart

// Make Chartkick available globally
window.Chartkick = Chartkick
